import { humanTimeDate } from '@/libs/dayjs';
import React from 'react';
import {
  ConversationType,
  UserConversation,
  UserConversationGroup,
} from '../../const';
import ReplyQuote from './ReplyQuote';

export const getMessageOwnerName = (
  sender: UserConversation | UserConversationGroup | undefined,
  isOwnMessage: boolean,
  ownerName: string,
  conversationType?: string
) => {
  if (isOwnMessage) {
    return conversationType === ConversationType.Group && (sender as UserConversationGroup)?.alias_name
      ? (sender as UserConversationGroup).alias_name
      : ownerName;
  }
  if (!sender) return 'Admin';
  if (sender.user_role !== 'user') return `An Thư Diamond - ${sender.user_name}`;
  return (sender as UserConversationGroup).alias_name ?? sender.user_name;
};

export const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.(?:com|net|org|io|co|vn|app|dev|info|biz|edu|gov|me|tv|ai|id|sg|ph|th|my|hk|tw|kr|uk|au|ca|de|fr|jp|cn|ru|br|in|it|es|nl|se|no|fi|dk|be|ch|at|pt)[^\s]*)/gi;

export const getHref = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

const renderContent = (text: string, isOwner: boolean) => {
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) => {
    if (URL_REGEX.test(part)) {
      URL_REGEX.lastIndex = 0;
      return (
        <a
          key={i}
          href={getHref(part)}
          target="_blank"
          rel="noopener noreferrer"
          className={`tw-underline tw-font-normal tw-text-blue-500`}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

type RenderMessageType = {
  userId: number;
  content: string;
  createdAt: string;
  idMessAd: number;
  ownerId: number;
  ownerName: string;
  sender: UserConversation | UserConversationGroup | undefined;
  conversationType?: string;
  replyMessageInfo?: any;
  compactTime?: boolean;
};

export const RenderMessage = (props: RenderMessageType) => {
  const {
    ownerId,
    ownerName,
    userId,
    idMessAd,
    content,
    createdAt,
    sender,
    conversationType,
    replyMessageInfo,
    compactTime = false,
  } = props;

  return (
    <div
      className={`${
        ownerId === userId
          ? 'chat-user custom-chat-user cu-rec'
          : 'custom-chat-admin ca-rec tw-break-all'
      }  ${
        ownerId === userId && !idMessAd ? 'custom-chat-user cu-rec' : ''
      } tw-px-4 tw-pt-2 tw-pb-1 tw-rounded-2xl tw-w-fit tw-relative tw-max-w-70 tw-break-all`}
    >
      {replyMessageInfo && (
        <ReplyQuote replyMessageInfo={replyMessageInfo} variant={ownerId === userId ? 'right' : 'left'} />
      )}
      {sender && ownerId !== userId && (
        <div
          className="consult-message-sender tw-text-secondary-30 tw-font-semibold tw-text-[15px]"
          style={{
            lineHeight: '15px',
          }}
        >
          {getMessageOwnerName(sender, false, ownerName, conversationType)}
        </div>
      )}
      {ownerId === userId && ownerName && (
        <div
          className="consult-message-sender tw-text-white tw-font-semibold tw-text-[15px]"
          style={{
            lineHeight: '15px',
          }}
        >
          {getMessageOwnerName(sender, true, ownerName, conversationType)}
        </div>
      )}
      <div
        className="tw-py-1 tw-text-[15px] tw-font-light"
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {renderContent(content, ownerId === userId)}
      </div>
      <div
        className={`consult-message-time tw-text-right ${
          ownerId === userId ? 'tw-text-white' : 'tw-text-secondary-50'
        }`}
        style={{
          fontSize: '9px',
        }}
      >
        {compactTime ? humanTimeDate(createdAt).slice(0, 5) : humanTimeDate(createdAt)}
      </div>
    </div>
  );
};
